import { RouteObject } from 'react-router-dom'
import IntegrationLogsPage from '../pages/integration-logs/IntegrationLogs.page'
import TenantIdBreadcrumb from '../components/common/TenantIdBreadCrumb'

export const integrationLogsRoutes: RouteObject = {
  path: 'logs/integration-logs',
  element: <IntegrationLogsPage />,
  handle: {
    crumb: () => <TenantIdBreadcrumb left={'Integration Logs - '} />,
  },
}
